// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/es6.array.is-array.js
// module id = 1477
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16